import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.s5w_1 = call;
        this.t5w_1 = data.y5k_1;
        this.u5w_1 = data.x5k_1;
        this.v5w_1 = data.a5l_1;
        this.w5w_1 = data.z5k_1;
        this.x5w_1 = data.c5l_1;
      }
      g5i() {
        return this.s5w_1;
      }
      ew() {
        return this.g5i().ew();
      }
      h5i() {
        return this.t5w_1;
      }
      i5i() {
        return this.u5w_1;
      }
      i2o() {
        return this.v5w_1;
      }
      a50() {
        return this.w5w_1;
      }
      a5i() {
        return this.x5w_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
